import { render } from "./ViewLocal.vue?vue&type=template&id=6280b248&scoped=true"
import script from "./ViewLocal.vue?vue&type=script&lang=js"
export * from "./ViewLocal.vue?vue&type=script&lang=js"

import "./ViewLocal.vue?vue&type=style&index=0&id=6280b248&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6280b248"

export default script